import type { ModelAddButtonOptions } from "@/modules/model-add-button";

import { UserAddOutlined } from "@ant-design/icons";

import UserCreate from "@/features/Users/Create";
import ModelAddButton from "@/modules/model-add-button";

const UserAddButton = (options: ModelAddButtonOptions) => {
  return (
    <ModelAddButton
      model="user"
      component={<UserCreate />}
      icon={<UserAddOutlined />}
      {...options}
    />
  );
};

export default UserAddButton;
